import { api } from "@/services/api";

import type { Character, CharacterOptions, CreateCharacterInput } from "./types";

export const characterApi = {
  options: (signal?: AbortSignal) => api.get<CharacterOptions>("/character/options/", { signal }),
  me: (signal?: AbortSignal) => api.get<Character>("/character/me/", { signal }),
  create: (input: CreateCharacterInput) => api.post<Character>("/character/", input),
};